
<div class='senior-drug-container'>
  @if (showDrugDataLoadingIndicator) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }

  @if (!showDrugDataLoadingIndicator && drugDetails) {
    <div class="estimated-cost">
      @if (drugDetails) {
        <div class="costs">
          <span class="value" [ngClass]="{ 'no-prescription-coverage-cost': !drugDetails.HasDrugCoverage }">${{ drugDetails.EstimatedAnnualDrugCostPartialYear }}</span>
          @if (drugDetails.HasDrugCoverage) {
            <span>Total Estimated Cost</span>
          }
          @if (!drugDetails.HasDrugCoverage) {
            <span class="no-prescription-coverage-label">Prescription Drugs Not Covered</span>
          }
        </div>
      }
      <div class="edit">
        <a href="" (click)="$event.preventDefault(); editPlanUsageFlow()">
          <span class="text">Edit</span>
        </a>
      </div>
    </div>
    @if (drugDetails) {
      <div class="coverage">
        @if (drugDetails.DosagesTotal.covered) {
          <span class="material-symbols-outlined covered-or-in-network">check_circle_outline</span>
        }
        @if (!drugDetails.DosagesTotal.covered) {
          <span class="material-symbols-outlined not-covered-out-of-network">highlight_off</span>
        }
        @if (drugDetails.DosagesTotal) {
          <span class="coverage-text">
            Prescription Coverage
            <span class="next-line-if-mobile">({{drugDetails.DosagesTotal.covered}} of {{drugDetails.DosagesTotal.selected}})</span>
          </span>
        }
      </div>
    }
    <button mat-button color="primary" (click)="showMedicalDetails()">
      Show Medication Details
    </button>
  }
</div>